import _ from "lodash";
import { SystemEventService } from "../domain/services/SystemEventService";
import {
    SystemEvent,
    SystemEventCollection,
} from "../domain/models/SystemEvent";
import { SystemEventsSearchFiltersDTO } from "../validation-schemas/SystemEventsSearchFiltersFields";
import { BaseServiceImpl } from "./BaseServiceImpl";
import { GET_ALL_RECORDS } from "../domain/constants";
import { SystemEventDTO } from "../domain/models/dto/SystemEventDTO";

export class SystemEventServiceImpl
    extends BaseServiceImpl
    implements SystemEventService {
    private readonly systemEventsEndpoint = "/api/v1/system-events";

    async getAll(
        currentPage: number,
        currentLimit: number,
        filtersDTO: SystemEventsSearchFiltersDTO = {} as SystemEventsSearchFiltersDTO
    ): Promise<SystemEventCollection> {
        const limit = currentLimit === GET_ALL_RECORDS ? 1000 : currentLimit;
        const offset = (currentPage - 1) * limit;
        let url = `${this.systemEventsEndpoint}?limit=${limit}&offset=${offset}`;

        const supportedApiParams = ["parentId", "parentType"];

        Object.entries(filtersDTO).forEach(([key, value]) => {
            if (!supportedApiParams.includes(key)) {
                return;
            }

            const isValidValue =
                !_.isNil(value) &&
                value !== GET_ALL_RECORDS &&
                (typeof value === "number" ||
                    typeof value === "boolean" ||
                    (typeof value === "string" && value.trim() !== ""));

            if (key && isValidValue) {
                url += `&${key}=${value}`;
            }
        });


        const result = await this.get<SystemEventCollection>(url);

        if (!result || !result.rows) {
            return {
                rows: [],
                totalRows: 0,
                totalPages: 0,
            };
        }

        return {
            ...result,
            rows: result.rows.map(
                (dto: SystemEventDTO) => new SystemEvent(dto) // TODO :: use mapper
            ),
        };

        // if (response?.status === "Bad Request" || response?.messages) {
        //     console.error('SystemEventServiceImpl - API Error:', response);
        //     throw new Error(response.messages?.join(', ') || 'Bad Request');
        // }

        // let data = _.get(response, "data", _.get(response, "rows", null));

        // if (!data && Array.isArray(response)) {
        //     data = response;
        // } else if (!data && response && typeof response === 'object') {
        //     const possibleKeys = ['data', 'rows', 'items', 'results', 'content'];
        //     for (const key of possibleKeys) {
        //         if (Array.isArray(response[key])) {
        //             data = response[key];
        //             break;
        //         }
        //     }
        // }

        // let rows = Array.isArray(data)
        //     ? data.map((item: any) => new SystemEvent(item))
        //     : [];

        // if (filtersDTO.eventType !== undefined && filtersDTO.eventType !== null && filtersDTO.eventType !== GET_ALL_RECORDS) {
        //     rows = rows.filter((event: SystemEvent) => event.eventType === filtersDTO.eventType);
        // }

        // const totalRowsFromApi = response?.dataRows || response?.totalRows || rows.length;

        // const result: SystemEventCollection = {
        //     rows,
        //     totalRows: totalRowsFromApi,
        //     totalCount: rows.length,
        //     totalPages: _.get(response, "totalPages", DEFAULT_PAGE),
        //     currentPage: _.get(response, "currentPage", _.get(response, "page", currentPage)),
        //     limit: _.get(response, "limit", _.get(response, "size", currentLimit)),
        // };

        // return result;
    }
}

export const systemEventServiceFactory = (): SystemEventService => {
    return new SystemEventServiceImpl();
};
